@if (description()) {
  <div class="input-field__described">
    <div class="input-field__described-label">
      {{ label() }}
      @if (required()) {
        <span class="input-field__described-required" aria-hidden="true">*</span>
      }
    </div>
    <p class="input-field__described-description" [id]="autId() + '-description'">{{ description() }}</p>
    <neo-form-field class="not-label" [class.hide-messages]="hideMessages()">
      <input
        #nativeInput
        neoInput
        class="input-field"
        [type]="type()"
        [required]="required()"
        [errorStateMatcher]="errorStateMatcher"
        [aria-describedby]="autId() + '-description'"
        [ngModel]="value"
        (ngModelChange)="onInputChange($event)"
        (blur)="onBlur()"
        [placeholder]="placeholder()"
        [disabled]="disabled"
        [attr.aut-id]="autId()"
        [attr.aria-label]="ariaLabel() || label() || null"
        [attr.autocomplete]="autocomplete()"
        [attr.min]="min()"
        [attr.max]="max()"
        [attr.maxlength]="maxlength()"
      />
      @if (hint() || (showCount() && maxlength() !== null)) {
        <neo-hint>{{ hint() || 'Max. ' + maxlength() + ' characters' }}</neo-hint>
      }
      @if (showCount()) {
        <neo-hint align="end">{{ countText() }}</neo-hint>
      }
      <cm-field-errors
        [control]="ngControl()?.control || null"
        [label]="label() || 'Field'"
        [customMessages]="errorMessages()"
        [showErrorsWhen]="showErrorsWhen()"
        [hideErrors]="hideErrors()"
        [constraints]="{
          maxlength: maxlength(),
          minlength: minlength(),
          min: min(),
          max: max()
        }"
      />
      <ng-content />
    </neo-form-field>
  </div>
} @else {
  <neo-form-field [class.not-label]="!label()" [class.hide-messages]="hideMessages()">
    <neo-label>{{ label() }}</neo-label>
    <input
      #nativeInput
      neoInput
      class="input-field"
      [type]="type()"
      [required]="required()"
      [errorStateMatcher]="errorStateMatcher"
      [ngModel]="value"
      (ngModelChange)="onInputChange($event)"
      (blur)="onBlur()"
      [placeholder]="placeholder()"
      [disabled]="disabled"
      [attr.aut-id]="autId()"
      [attr.aria-label]="ariaLabel() || null"
      [attr.autocomplete]="autocomplete()"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.maxlength]="maxlength()"
    />
    @if (hint() || (showCount() && maxlength() !== null)) {
      <neo-hint>{{ hint() || 'Max. ' + maxlength() + ' characters' }}</neo-hint>
    }
    @if (showCount()) {
      <neo-hint align="end">{{ countText() }}</neo-hint>
    }

    <!-- Error messages via reusable component -->
    <cm-field-errors
      [control]="ngControl()?.control || null"
      [label]="label() || 'Field'"
      [customMessages]="errorMessages()"
      [showErrorsWhen]="showErrorsWhen()"
      [hideErrors]="hideErrors()"
      [constraints]="{
        maxlength: maxlength(),
        minlength: minlength(),
        min: min(),
        max: max()
      }"
    />

    <!-- Legacy ng-content projection for backward compatibility -->
    <ng-content />
  </neo-form-field>
}
